// extracted by mini-css-extract-plugin
export var border = "_5g-0";
export var borderSelected = "_5g-1";
export var check = "_5g-6";
export var circle = "_5g-2";
export var circleInner = "_5g-4";
export var circleInnerDisabled = "_5g-8";
export var description = "_5g-3";
export var horizontal = "_5g-b";
export var input = "_5g-5";
export var label = "_5g-9";
export var radioButton = "_5g-d";
export var radioButtonNoCenter = "_5g-e";
export var radioGroup = "_5g-a";
export var rightRadio = "_5g-f";
export var subcontent = "_5g-g";
export var uncheck = "_5g-7";
export var vertical = "_5g-c";